import React from 'react'
import ToDo from './Components/ToDo';

const App = () => {
  return (
    <>
      <ToDo />
    </>
  )
}

export default App;
